<div class="redemption-container">
  <div class="hero">
    <!-- <div>
      <div class="image">
        <img src="/assets/tytnetwork-light-shadow.png" />
        <div class="tagline">7 Billion Views | 6 Million Subscribers</div>
      </div>
      <div class="flex-spacer"></div>
      <div class="sign-in">

      </div>
    </div> -->
  </div>
  <div class="spinner-holder" *ngIf="submitting">
      <app-spinner></app-spinner>
  </div>
  <div class="redemption" *ngIf="giftItem && !submitting">

    <img class="theme-name" [src]="themeUrl" alt="iguana">

    <p *ngIf="giftItem">{{welcome}}</p>
    <ng-container *ngIf="alreadyHasMembership">
      <p>Uh oh! The account you are logged into already has an active membership! Gifts can only be redeemed 
        by users who do not currently have a TYT membership. You are currently logged in as <strong>{{user.email}}</strong>.</p>
      <p>To see your current membership details, <a routerLink="/account">click here</a>.</p>
      <p>If you wish to apply this gift to a different account (or a new account), <a routerLink="/logout">log out of this account</a> and 
        click the Redeem link again from the email that you received.</p>
    </ng-container>
    <ng-container *ngIf="!alreadyHasMembership && giftItem">
      <p *ngIf="!giftItem.sponsorship">Let's get you started on your {{ giftProductName }} gift subscription from {{ capitalizeFirstLetter(giftItem.purchaser_name)}}.</p>
      <p *ngIf="giftItem.sponsorship">Let's get you started on your {{ giftProductName }} gift membership package.</p>
      <div *ngIf="user">
        <p>
          Since you're already logged in, we're going to apply your gift to your existing account.  If that is not your intent, please log out from TYT.com and then click through the redemption link in your gift email again.
        </p>

        <div class="form-group text-field" *ngIf="giftItem.sponsorship">
          <p>
            (Optional) <br/> Write a thank you note, they'd
            love to hear from you!  We'll only share your first name and your note with the purchaser of the gift package.
          </p>
          <textarea class="form-control" rows="4" id="message" id="message" name="message" value="message" [(ngModel)]="message"></textarea>
        </div>

        <div class="actions">
          <a routerLink="/logout" class="logout">Log out</a>
          <button class="apply-gift" (click)="redeemGift()">Apply gift to this account</button>
        </div>

      </div>
      <div *ngIf="!user">
        <p>
          You're about to get the best progressive news and talk for the connected generation.
        </p>
        <p>
          To access your membership benefits, just provide an email, name, and password. You will sign in using that information going forward to access member content on <a href="javascript:;" routerLink="/" target="_blank">TYT.com</a> and the TYT Plus app for Android and iOS.
        </p>

        <strong>Not a member but have a TYT log in?</strong>
        <p>To redeem the gift membership package using your TYT account: Sign into your account, then click the Redeem link from your email again.</p>

        <hr/>
        <error-message [producer]="this"></error-message>
        
        <app-form #form [handler]="this" class="register" action="/gift/redemption/:code" [handler]="this" class="form-fields">
          <error-message></error-message>
          <div *ngIf="existingEmailError" class="alert alert-danger">
            <a routerLink="/login">Log in</a> to apply this gift package to your account.
          </div>

          <label>What email address do you want to log in with?</label>
          <div class="form-group text-field">
            <label for="email">Email Address</label>
            <input errorHighlight type="text" class="form-control" id="email" name="email" [(ngModel)]="email" required>
          </div>

          <div class="form-group text-field">
            <label for="recipient-name">First Name</label>
            <input errorHighlight type="text" class="form-control" id="recipient-name" name="recipient-name" [(ngModel)]="recipient_name" required>
          </div>

          <div class="form-group text-field">
            <label for="password">Password</label>
            <input errorHighlight type="password" class="form-control" id="password" name="password" [(ngModel)]="password" required>
          </div>

          <div class="form-group text-field">
            <label for="confirm-password">Confirm Password</label>
            <input errorHighlight type="password" class="form-control" id="confirm-password" name="confirm-password" [(ngModel)]="confirmPassword" required>
          </div>

          <div class="form-group text-field" *ngIf="giftItem.sponsorship">
            <p>
              (Optional) <br/> Write a thank you note, they'd
              love to hear from you! We'll only share your first name and your note 
              with the purchaser of the gift package.
            </p>
            <textarea class="form-control" rows="4" id="message" id="message" name="message" value="message" [(ngModel)]="message"></textarea>
          </div>

          <button class="signup">Next</button>
        </app-form>
      </div>
    </ng-container>
  </div>
</div>